import { TablePaginationConfig } from "antd";
import { OtpApi } from "api/opt";
import { useDataLoadingContext } from "contexts/DataLoadingContext";
import { useNotificationContext } from "contexts/NotificationContext";
import { defaultTableData, ITableData } from "models";
import { IAppVersion } from "models/appVersion";
import { ChangeEvent, useEffect, useState } from "react";

export default function useOtp() {
  const { showError } = useNotificationContext();
  const { reloadOtp } = useDataLoadingContext();
  const [data, setData] = useState<ITableData<IAppVersion>>(defaultTableData);

  useEffect(() => {
    fetchOtp();
  }, [data.page, data.search, reloadOtp]); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchOtp = async () => {
    setData((prev) => ({ ...prev, loading: true }));

    const { data: response, error } = await OtpApi({
      page: data.page,
      per_page: data.per_page,
      search: data.search,
    });
    if (response) {
      response.data = response.data.map((value) => ({
        ...value,
        key: value.id,
      }));
      setData((prev) => ({ ...prev, ...response, loading: false }));
    } else {
      showError(error!.message);
      setData((prev) => ({ ...prev, loading: false }));
    }
  };

  const handlePageChange = ({ current }: TablePaginationConfig) => {
    if (current) setData((prev) => ({ ...prev, page: current }));
  };

  const handleSearch = ({
    target: { value },
  }: ChangeEvent<HTMLInputElement>) => {
    setData((prev) => ({ ...prev, search: value ?? "" }));
  };

  return {
    data,
    handlePageChange,
    handleSearch,
  };
}
